/**
 * @format
 */
export const TOGGLE_LOADING = 'toggle_loading';
export const SET_ERROR = 'set_error';
